import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface CountdownModalProps {
  redirectTo?: string;
}

const CountdownModalToRedirect: React.FC<CountdownModalProps> = ({ redirectTo = "/" }) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(3);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      navigate(redirectTo);
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate, redirectTo]);

  return (
    <div className="fixed inset-0 z-[5000] bg-black bg-opacity-50 flex items-center justify-center ">
      <div className="bg-white dark:bg-gray-700 rounded-2xl shadow-xl p-6 w-full max-w-sm text-center">
        <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-slate-100">Out of Scope</h2>
        <p className="mb-2 text-gray-700 dark:text-slate-100">Your response is not related to the interview content. You will be redirected in to interview setup page</p>
        <div className="text-4xl font-bold text-red-600">{secondsLeft}</div>
      </div>
    </div>
  );
};

export default CountdownModalToRedirect;
